import { render, staticRenderFns } from "./mobileNews.vue?vue&type=template&id=3b5cedc7&scoped=true"
import script from "./mobileNews.vue?vue&type=script&lang=js"
export * from "./mobileNews.vue?vue&type=script&lang=js"
import style0 from "./mobileNews.vue?vue&type=style&index=0&id=3b5cedc7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5cedc7",
  null
  
)

export default component.exports